

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Banner from '@/components/banner/Bannerwrap.vue';
import KnowMoreBtn from '@/components/know-more-button/Know-more-btn.vue';

import axios from 'axios';
import {
  getProductdetailUrl,
} from '@/util/lang.ts';

import imgs from '@/util/imgs.ts';
import qs from 'qs';
import i18n from '@/plugins/i18n';

@Component({
  components: {
    Banner,
    KnowMoreBtn,
  },
})
export default class Productdetail extends Vue {
  // initial data
  private imgs = imgs;
  private iszoom: boolean = false;

  private item: object = {
    PRONAME: '',
    MEMO: '',
    CONTENT: '',
  };
  private form = {
    theme:'',
    content:'',
    CompanyType:'',
    CorporateName:'',
    name:'',
    email:'',
    tel:'',
    website: '',
  };
  private rules = {
    theme: [
      { required: true, message: i18n.t('contact_page.formRules.theme'), trigger: 'blur', }
    ],
    content: [
      { required: true, message: i18n.t('contact_page.formRules.content'), trigger: 'blur', }
    ],
    CompanyType: [
      { required: true, message: i18n.t('contact_page.formRules.CompanyType'), trigger: 'blur', }
    ],
    CorporateName: [
      { required: true, message: i18n.t('contact_page.formRules.CorporateName'), trigger: 'blur', }
    ],
    name: [
      { required: true, message: i18n.t('contact_page.formRules.name'), trigger: 'blur', }
    ],
    email: [
      { required: true, message: i18n.t('contact_page.formRules.email'), trigger: 'blur', }
    ],
    tel: [
      { required: true, message: i18n.t('contact_page.formRules.tel'), trigger: 'blur', }
    ],
  };

  @Watch('$route')
  private onRouteChanged(to: any) {
    // const line = (to && to.meta && to.meta.line) || 'home';
    // this.initLine(line);
    // window.console.log(to);
    this.fetchData();
  }

  // lifecycle hook
  private mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      this.iszoom = true;
    });

    this.fetchData();
  }

  private submitForm(query: any) {
    (this.$refs['form'] as any).validate((valid: any) => {
          if (valid) {
            axios({
              method: 'post',
              url: 'http://dentik.sansg.com/php/form.php',
              data: qs.stringify(this.form)
            }).then((res: any) => {
              this.form={
                theme:'',
                content:'',
                CompanyType:'',
                CorporateName:'',
                name:'',
                email:'',
                tel:'',
                website: '',
              };
              /* this.$message({
                message: i18n.t('contact_page.success'),
                type: 'success',
              }); */
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    
  }

  private fetchData() {
    // window.console.log(this.$route.params.id);
    const id = this.$route.params.id;
    if (id) {
      // const url = `/php/product.php?pid=${id}`;
      const url = getProductdetailUrl(id);
      axios.get(url).then((res: any) => {
        // window.console.log(res.data.proarr);
        this.item = res.data.proarr;
      });
    }
  }

  private backList() {
    // window.console.log('backList');
    // this.$router.back();
    this.$router.push('/productlist');
  }
}
